/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsOptimizesAzureAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsOptimizesAzureAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsOptimizesAzureAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsOptimizesAzureAdvisorResource>): RecommendationForFinopsOptimizesAzureAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsOptimizesAzureAdvisorResource(), model);
        RecommendationForFinopsOptimizesAzureAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsOptimizesAzureAdvisorResource>): RecommendationForFinopsOptimizesAzureAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsOptimizesAzureAdvisorResource.newInstance(<RecommendationForFinopsOptimizesAzureAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsOptimizesAzureAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsOptimizesAzureAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsOptimizesAzureAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsOptimizesAzureAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
